export const ACCEPT_COOKIES_KEY = "uack";
